import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  ExcelImportPreviewRow,
  ExcelImportPreviewTableTexts,
} from './excel-import-preview-table.model';

/**
 * One "rows × years" preview table for an Excel import modal (budget kostnader/finansiering,
 * upparbetade kostnader) — identical rendering regardless of which import feature uses it.
 */
@Component({
  selector: 'lib-excel-import-preview-table',
  templateUrl: './excel-import-preview-table.component.html',
  styleUrl: './excel-import-preview-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class ExcelImportPreviewTableComponent {
  readonly title = input.required<string>();
  readonly years = input.required<number[]>();
  readonly rows = input.required<ExcelImportPreviewRow[]>();
  readonly texts = input.required<ExcelImportPreviewTableTexts>();
  /** Overrides the bare year header for a column, e.g. to show a partial-year period's actual date range. */
  readonly columnLabels = input<Record<number, string>>({});
}
